import { useEffect, useState } from "react";
import "../../assets/css/park-image.css"

export default function ParkImagesModal({ open, activeImageIndex, handleClose, images }) {
    const [activeImage, setActiveImage] = useState(activeImageIndex);
    const [startSlideIndex, setStartSlideIndex] = useState(0);
    const [endSlideIndex, setEndSlideIndex] = useState(0);

    const handleIncrementActiveImage = () => {
        setActiveImage((active) => active + 1);
    };

    const handleDecrementActiveImage = () => {
        setActiveImage((active) => active - 1);
    };

    useEffect(() => {
        if (images?.length) {
            const { length } = images;

            if (length <= 5) {
                setStartSlideIndex(0);
                setEndSlideIndex(length);
            } else if (activeImage <= 2) {
                setStartSlideIndex(0);
                setEndSlideIndex(5);
            } else if (length - 2 <= activeImage) {
                setStartSlideIndex(length - 5);
                setEndSlideIndex(length);
            } else {
                setStartSlideIndex(activeImage - 2);
                setEndSlideIndex(activeImage + 3);
            }
        }
    }, [activeImage, images]);

    if (!open) return null;



    return <div id="imageModal" className="modal-overlay">
        <div className="image-modal-box">
            <div className="header">
                <p>Photos</p>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleClose}
                />
            </div>
            <div className="body">

                {images?.[activeImage] && (
                    <img
                        src={images[activeImage].image}
                        alt={images[activeImage].alt}
                        className="img-fluid main-image"
                    />
                )}
                <div className="centered-navigation">
                    <button
                        type="button"
                        onClick={handleDecrementActiveImage}
                        disabled={activeImage === 0}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        onClick={handleIncrementActiveImage}
                        disabled={activeImage === images.length - 1}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="footer">
                {images &&
                    images
                        .slice(startSlideIndex, endSlideIndex)
                        .map((photo, index) => (
                            <button
                                key={photo.alt}
                                type="button"
                                className={`image-list ${activeImage === startSlideIndex + index ? "active" : ""}`}
                                onClick={() => setActiveImage(startSlideIndex + index)}
                            >
                                <img
                                    src={photo.image}
                                    alt={photo.alt}
                                />
                            </button>
                        ))}

            </div>
        </div>
    </div>
}